<template>
    <div class="date-input">
        <v-menu
                v-model="menu"
                :close-on-content-click="false"
                offset-y
                min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-model="localValue"
                        :label="label"
                        readonly
                        v-on="on"
                        hide-details
                        outlined
                        hide-details="auto"
                ></v-text-field>
            </template>
            <v-date-picker v-model="localValue" @input="menu = false"></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: null
            },
            label: String,
            name: String
        },
        data() {
            return {
                localValue: this.value,
                menu: false
            }
        },
        watch: {
            value(v) {
                this.localValue = v;
            },
            localValue(v) {
                this.$emit('input', v);
            }
        }
    }
</script>